module.exports = __webpack_public_path__ + "static/cafe03-1f6cfa71b8c9ff7b81501e7056363195.jpg";